import Vue from 'vue';
import Vuex from 'vuex';
import { applyPlugin, reducePlugin, warn, error } from '~/lib.js';
import _app from '../stores/app.js';
import _callUserConfig from '../stores/callUserConfig.js';
import _im from '../stores/im';
import _recordform from '../stores/recordform.js';
import _workbench from '../stores/workbench.js';

const GLOBAL_STORES = [
  { namespace: 'app', exported: _app },
  { namespace: 'callUserConfig', exported: _callUserConfig },
  { namespace: 'im', exported: _im },
  { namespace: 'recordform', exported: _recordform },
  { namespace: 'workbench', exported: _workbench }
];
const NAMESPACE_CACHE = {};

Vue.use(Vuex);

const storeOption = getRootStore();
applyPlugin('beforeStoreCreate', storeOption);
const ROOT_STORE = new Vuex.Store(storeOption);
applyPlugin('afterStoreCreate', ROOT_STORE, { registerStore });
GLOBAL_STORES.forEach(setupStoreFile);
export default ROOT_STORE;

export function registerPagesStore(asyncImports, namespaces) {
  return Promise.all(asyncImports).then(exportStores =>
    exportStores.forEach((exported, i) => {
      if (namespaces[i]) {
        setupStoreFile({
          namespace: namespaces[i],
          exported
        });
      }
    })
  );
}

function setupStoreFile(storeMap) {
  let { namespace, exported } = storeMap;
  if (exported) {
    // 模块导出
    const storeOpts = { ...(exported = exported.default || exported) };
    // 模块名
    storeOpts.namespace =
      typeof exported.namespace === 'string' ? exported.namespace : namespace;
    registerStore(storeOpts);
  }
}

function getRootStore() {
  if (GLOBAL_STORES.length === 1) {
    const baseStore = GLOBAL_STORES[0];
    if (baseStore && !baseStore.namespace) {
      GLOBAL_STORES.shift();
      const {
        subscribe,
        subscribeAction,
        ...moduleOption
      } = baseStore.exported;
      addMutationSubscribe(subscribe);
      addActionSubscribe(subscribeAction);
      return moduleOption;
    }
  }
  return {};
}

function registerStore(storeOption) {
  const { namespace } = storeOption;
  if (!namespace) {
    warn(`store need set namespace`, storeOption);
    return;
  }
  // 重复注册
  if (NAMESPACE_CACHE[namespace]) {
    return;
  }
  let registerName = namespace;
  // 嵌套模块
  if (namespace.includes('/')) {
    registerName = namespace.split('/');
    const temp = registerName.slice(0);
    temp.pop();
    if (temp.some(key => !NAMESPACE_CACHE[key])) {
      warn(
        `module ${namespace} register fail, can't find parent module, skiped`
      );
      return;
    }
  }

  try {
    let { subscribe, subscribeAction, ...moduleOption } = storeOption;
    moduleOption = reducePlugin('beforeRegisterModule', moduleOption);
    if (moduleOption) {
      moduleOption.namespaced = true; // 模块化
      NAMESPACE_CACHE[namespace] = 1;
      ROOT_STORE.registerModule(registerName, moduleOption);
      addMutationSubscribe(subscribe);
      addActionSubscribe(subscribeAction);
    }
  } catch (e) {
    error(e);
  }
}

function addActionSubscribe(subscribe) {
  if (subscribe && ROOT_STORE.subscribeAction) {
    // > vuex@3.1.0
    if ('before' in subscribe || 'after' in subscribe) {
      subscribe.before = normalizeSubscribe(subscribe.before);
      subscribe.after = normalizeSubscribe(subscribe.after);
      return ROOT_STORE.subscribeAction(subscribe);
    }
    subscribe = normalizeSubscribe(subscribe);
    if (subscribe) {
      ROOT_STORE.subscribeAction(subscribe);
    }
  }
}

function addMutationSubscribe(subscribe) {
  if (subscribe) {
    subscribe = normalizeSubscribe(subscribe);
    if (subscribe) {
      ROOT_STORE.subscribe(subscribe);
    }
  }
}

function normalizeSubscribe(subscribe) {
  switch (typeof subscribe) {
    case 'object':
      return event => {
        const callbck = subscribe[event.type];
        switch (typeof callbck) {
          case 'function':
            callbck(ROOT_STORE, event.payload);
            break;
          case 'string':
            ROOT_STORE.dispatch(callbck, event.payload);
            break;
        }
      };
    case 'function':
      return event => subscribe(ROOT_STORE, event);
  }
}
